<template>
  <div>
    <v-row no-gutters class="my-2">
      <v-col cols="12" md="6" lg="4">
        <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
          <div class="px-2 py-1">
            <div>Télécharger un justificatif de paiement</div>
            <div class="text-subtitle-1">pour cette commande</div>
          </div>
          <div>

            <a :href="base_url + 'user/commande/justificatif/download.php?id=' + commande.id + '&token=' + mainStore.authUser.userData.token"
              target="_blank"><v-btn color="darkblue" variant="tonal" elevation="0" block
                class="h-100 rounded-0"><v-icon icon="mdi-download" size="x-large"></v-icon></v-btn></a>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
          <div class="px-2 py-1">
            <div>Renvoyer le mail de confirmation</div>
            <div class="text-subtitle-1">à {{ mainStore.authUser.userMail }}</div>
          </div>
          <div>
            <v-btn color="darkblue" variant="tonal" elevation="0" block class="h-100 rounded-0"
              @click="resend_confirm_email()"><v-icon icon="mdi-email-plus-outline" size="x-large"></v-icon></v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
          <div class="px-2 py-1">
            <div>Ajouter des options</div>
            <div class="text-subtitle-1">aux inscrits de cette commande</div>
          </div>
          <div>
            <router-link :to="{ name: 'AddOptions', params: { id_commande: commande.id } }"><v-btn color="darkblue"
                variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon icon="mdi-basket-plus-outline"
                  size="x-large"></v-icon></v-btn></router-link>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-snackbar v-model="display_snackbar">
      {{ text_snackbar }}
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="display_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
export default {
  props: ["item"],
  data() {
    return {
      display_snackbar: false,
      text_snackbar: "",
      commande: {},
      base_url: process.env.VUE_APP_API_BASE,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },

  methods: {
    async resend_confirm_email() {
      let response = await UserService.sendCommandeConfirmationEmail(this.commande.uuid);
      this.text_snackbar = response;
      this.display_snackbar = true;
    },
  },
  created() {

    this.commande = this.item;
  },
};
</script>

<style lang="scss" scoped></style>